import React from "react";
import SnackbarContext from "./SnackbarContext";
import Snackbar from "./Snackbar";

export default function SnackbarProvider({ children }) {
  const [state, setState] = React.useState({});

  /**
   * Display a message with this snackbar.
   * @param {string} text message to display
   * @param {object} snackbarProps object with Karsten Snackbar props
   * @public
   */
  const showMessage = React.useCallback((text, snackbarProps) => {
    setState({ open: true, text, ...snackbarProps });
  }, []);

  const closeMessage = React.useCallback(() => {
    setState((prev) => ({
      open: false,
      text: "",
      snackbarProps: prev.snackbarProps,
    }));
  }, []);

  const contextValue = React.useMemo(
    () => ({ showMessage, closeMessage }),
    [showMessage, closeMessage],
  );

  return (
    <>
      <SnackbarContext.Provider value={contextValue}>
        {children}
      </SnackbarContext.Provider>
      <Snackbar
        {...state}
        open={state.open && state.text?.length > 0}
        onClose={closeMessage}
      />
    </>
  );
}
